<template>
    <DsModalDialog
        :model-value="isVisible"
        :top-divider-visible="false"
        :bottom-divider-visible
        :has-dialog-close-btn="false"
        @update:model-value="handleModalClosed"
        :animate
        :css-class="modalClasses"
    >
        <template #top>
            <DsLargeIcon v-if="icon" :name="icon" :size="isSm ? 100 : 80" class="ds-modal-alert__picture" />
            <DsTopSlotHeadlineSubheadline :headline="title" :display-headline-as-html="true" :subheadline="subText" />
        </template>
        <template #bottom>
            <div
                class="ds-modal-alert__buttons"
                :class="[
                    `ds-modal-alert__buttons--${buttonsFlexDirection}`,
                    { 'ds-modal-alert__buttons--no-margin': bottomDividerVisible },
                ]"
            >
                <DsButton
                    v-if="btnConfirmText"
                    :href="btnConfirmHref"
                    class="ds-modal-alert__button"
                    :type="btnConfirmType"
                    @click="ctaClickHandler"
                    >{{ btnConfirmText }}</DsButton
                >
                <DsButton
                    class="ds-modal-alert__button"
                    :class="btnCloseClass"
                    @click="handleModalClosed"
                    :type="btnCloseType"
                    >{{ btnCloseText }}</DsButton
                >
            </div>
            <span v-if="errorCode" class="ds-modal-alert__code">ecode: {{ errorCode }}</span>
        </template>
    </DsModalDialog>
</template>

<script lang="ts" setup>
import { computed, nextTick, onMounted, ref } from "vue";
import { useBreakpoints } from "@allwyn/utils/composables/use-breakpoints";
import { DsModalAlertModel } from "./ds-modal-alert-model";
import DsButton from "../button/ds-button.vue";
import DsLargeIcon from "../icon/ds-large-icon.vue";
import DsModalDialog from "../modal-dialog/ds-modal-dialog.vue";
import DsTopSlotHeadlineSubheadline from "../top-slot/ds-top-subheadline.vue";

const props = withDefaults(defineProps<DsModalAlertModel>(), {
    btnCloseType: "primary",
    btnConfirmType: "primary",
    btnCloseText: "OK",
    bottomDividerVisible: false,
    animate: true,
    icon: null,
    href: null,
    buttonsFlexDirection: "column",
    isWide: false,
});

const isVisible = ref(props.animate ? false : true);
const isSm = useBreakpoints("sm");

onMounted(() => {
    if (props.animate) {
        nextTick(() => {
            isVisible.value = true;
        });
    }
});

const handleModalClosed = () => {
    isVisible.value = false;

    if (props.onClosed) {
        props.onClosed();
    }
};

const ctaClickHandler = () => {
    if (props.btnConfirmClickHandler) {
        props.btnConfirmClickHandler();
    }

    handleModalClosed();
};

const modalClasses = computed(() => {
    const classes = [props.modalClass, "ds-modal-alert"];
    if (props.isWide) {
        classes.push("ds-modal-alert--wide");
    }

    return classes;
});
</script>
